import { ResetPassword } from './ResetPassword'

export const ResetPage = () => {
  return <ResetPassword />
}

export default ResetPage
